import { InjectionToken } from '@angular/core';
export interface DocumentUploadTranslations {
  deleteButtonLabel: string;
  dictFileTooBig: string;
  dictInvalidFileType: string;
  noFileSelectedLabel: string;
  uploadButtonLabel: string;
  uploadSystemErrorMessage: string;
  dragAndDropLabel: string;
  dragAndDropHint: string;
}

export const documentUploadDefaultTranslations: DocumentUploadTranslations = {
  deleteButtonLabel: 'Delete',
  dictFileTooBig: 'Selected file is too big.',
  dictInvalidFileType: 'Invalid file type selected.',
  noFileSelectedLabel: 'No file selected.',
  uploadButtonLabel: 'Upload',
  uploadSystemErrorMessage: 'An error occurred',
  dragAndDropLabel: 'Drag & drop or click to upload document.',
  dragAndDropHint: 'Drop file here'
};

export const DOCUMENT_UPLOAD_TRANSLATIONS = new InjectionToken<DocumentUploadTranslations>(
  'DOCUMENT_UPLOAD_TRANSLATIONS'
);
